import { Col, Row, Text } from '@ksyos/design-system';
import type { ITimeRange } from '@common/validation/callBackMoment';
import type { ValidationErrors } from '@frontend/utils';
import { useViewportWidth } from '@frontend/utils';
import { translateKey } from '../../translate/index';
import { TimeInput } from '../fields';

export interface ITimeRangeAddEditProps extends ITimeRange {
    endTimePlaceholder?: string;
    error?: string;
    errors: ValidationErrors;
    onChange: (value: string | null, period: keyof ITimeRange) => void;
    onDoValidate?: () => void;
    startTimePlaceholder?: string;
}

export function TimeRangeAddEdit(props: ITimeRangeAddEditProps) {
    const { width } = useViewportWidth();

    return (
        <Row columnGap={4}>
            <Col span={width > 1250 ? 5 : 12}>
                <TimeInput
                    className="pl-1 pr-1"
                    error={props.errors.get(`${props.error}.startTime`)}
                    onChange={async (value) => props.onChange(value, 'startTime')}
                    onDoValidate={async () => props.onDoValidate?.()}
                    placeholder={props.startTimePlaceholder}
                    value={props.startTime}
                />
            </Col>
            <Col span={width > 1250 ? 2 : 12}>
                <Text
                    as="small"
                    mt={3}
                    size="sm"
                    textAlign="center"
                >
                    {translateKey('common.to')}
                </Text>
            </Col>
            <Col span={width > 1250 ? 5 : 12}>
                <TimeInput
                    className="pl-1 pr-1"
                    error={props.errors.get(`${props.error}.endTime`)}
                    onChange={async (value) => props.onChange(value, 'endTime')}
                    onDoValidate={async () => props.onDoValidate?.()}
                    placeholder={props.endTimePlaceholder}
                    value={props.endTime}
                />
            </Col>
        </Row>
    );
}
